// eslint-disable-next-line
import util from 'util';
import PropTypes from 'prop-types';
// eslint-disable-next-line
import React, { Component } from 'react';
// import * as MuiCore from '@material-ui/core';


/*
 * Display text display with phone numbers and email addresses hyperlinked
 */
class LinkedText extends Component {

  linkClicked = (segment, event) => {
    event.stopPropagation()
    if (typeof(this.props.onClick) === 'function') {
      this.props.onClick(segment, event.currentTarget);
    }

  }

  render() {
    if (!this.props.value) {
      return('');
    }
    let matches = [...this.props.value.matchAll(this.props.contactMethodRegexp)];
    let key = 0;

    return(matches.map((match, index) => {
      key++;
      if (match.groups.text) {
        return(match.groups.text);
      }
      if (match.groups.email) {
        return(<span key={key}
                     style={{cursor: 'pointer', fontFamily:'Sofia'}}
                     className='MuiLink-root MuiLink-underlineHover'
                     onClick={(event) => this.linkClicked({ type: 'EMAIL' ,
                                                            value : match.groups.email}, event)}>{match.groups.email}</span>);
      }
      if (match.groups.phone) {
        /* Phone numbers must also have at least 10 digits */
        let digits = match.groups.phone.replace(/\D/g, '');
        if (digits.length >= 10) {
          return(<span key={key}
                       style={{cursor: 'pointer', fontFamily:'Sofia'}}
                       className='MuiLink-root MuiLink-underlineHover'
                       onClick={(event) => this.linkClicked({ type : 'PHONE',
                                                              value : match.groups.phone}, event)}>{match.groups.phone}</span>);
        } else {
          return(match.groups.phone);
        }
      }
      return('');
    }));
  }
}

LinkedText.propTypes = {
  /* Text to to display */
  value : PropTypes.string,

  /* Called when  link is clicked.  The first parmeter an object with a type and
     value property */
  onClick: PropTypes.func,

  /* Regular expression for contact methods.  Group 1 for email and group 2 
     for phone numbers */
  contactMethodRegexp : PropTypes.object,

  /* Style class for phone links */
  phoneClass : PropTypes.string,
  
  /* Style class for email links */
  emailClass : PropTypes.string,
}

LinkedText.defaultProps = {
  contactMethodRegexp : /(?:^|\\s)(?<email>\S+@\S+\.\S+)|(?<phone>\+?\d[\s\d()-]+)|(?<text>.+?)(?:$|\\s)/gimu,
}


export default LinkedText;
